
import React from 'react'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'

import { cn } from '@shared/lib/cn'

import styles from './Gallery.module.scss'

interface GalleryFile {
  url: string;
}

interface GalleryProps {
  data: {
    files?: GalleryFile[];
  };
  className?: string;
}

export type { GalleryFile }
export type GalleryData = GalleryProps['data'];

const Gallery: React.FC<GalleryProps> = ({ data, className }) => {
  const { files } = data
  const isTablet = useMediaQuery('(max-width: 768px)')

  if (!files || files.length === 0) {
    return null
  }

  const showNavigation = !isTablet && files.length > 1

  return (
    <>
      {files && files.length > 0 && (
        <Swiper
          className={cn('_navigation-center', styles.swiper, className)}
          modules={[ Navigation ]}
          spaceBetween={20}
          navigation={showNavigation || false}
          loop={files && files.length > 1}
          breakpoints={{
            0: {
              slidesPerView: 'auto',
              centeredSlides: true,
            },
            769: {
              slidesPerView: 1,
            },
          }}
        >
          {files &&
            files.map((file, index) => {
              return (
                <SwiperSlide className={styles.slide} key={index}>
                  <div className={styles.imageWrapper}>
                    <img
                      src={file.url}
                      className={styles.image}
                      loading="lazy"
                    />
                  </div>
                </SwiperSlide>
              )
            })}
        </Swiper>
      )}
    </>
  )
}

export default Gallery
